import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import useFetchRTPWithdrawTransaction from '../../../../hooks/useApi/useFetchRTPWithdrawTransaction';
import RTPWithdrawalInfo from './RTPWithdrawalInfo';

type TransactionProps = {
  TransactionID: string;
  Notes: string;
  jwt: string;
  ELinxRequestID?: string;
};
type FC = FunctionComponent<TransactionProps>;

const RTPWithdrawalContainer: FC = (props: TransactionProps) => {
  const { TransactionID, Notes, jwt, ELinxRequestID = '' } = props;
  const [RTPWithdrawTransaction, getRTPWithdrawTransaction] = useFetchRTPWithdrawTransaction({ bearer: jwt });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.RTPWithdrawTransactionResponse>();

  useEffect(() => {
    getRTPWithdrawTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (RTPWithdrawTransaction && RTPWithdrawTransaction.Success) {
      setTransaction(RTPWithdrawTransaction);
    }
  }, [RTPWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <RTPWithdrawalInfo transaction={transaction} Notes={Notes} jwt={jwt} ELinxRequestID={ELinxRequestID} />}</div>;
};

export default RTPWithdrawalContainer;
